import { getSeason } from "@/data/season";

// Flocons de neige délicats pour le thème Noël (positions/délais fixes, mouvement doux).
function ChristmasDecor() {
  const flakes = [
    { left: "6%", size: 5, delay: "0s", dur: "11s" }, { left: "14%", size: 3, delay: "2.5s", dur: "13s" },
    { left: "22%", size: 4, delay: "1s", dur: "10s" }, { left: "31%", size: 3, delay: "4s", dur: "14s" },
    { left: "39%", size: 5, delay: "0.5s", dur: "12s" }, { left: "47%", size: 3, delay: "3s", dur: "11s" },
    { left: "55%", size: 4, delay: "1.8s", dur: "13s" }, { left: "63%", size: 3, delay: "5s", dur: "10s" },
    { left: "71%", size: 5, delay: "2s", dur: "14s" }, { left: "79%", size: 3, delay: "0.8s", dur: "12s" },
    { left: "87%", size: 4, delay: "3.5s", dur: "11s" }, { left: "94%", size: 3, delay: "1.2s", dur: "13s" },
  ];
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-[5] overflow-hidden">
      {flakes.map((f, i) => (
        <span
          key={i}
          className="animate-snowfall absolute top-0 rounded-full bg-cream/70"
          style={{ left: f.left, width: f.size, height: f.size, animationDelay: f.delay, animationDuration: f.dur }}
        />
      ))}
      {/* Étoile scintillante — haut droit */}
      <svg className="animate-twinkle absolute right-[10%] top-[14%] h-8 w-8 text-terracotta/80" viewBox="0 0 40 40" fill="currentColor">
        <path d="M20 2 L23.5 15 L37 15 L26 23 L30 37 L20 28 L10 37 L14 23 L3 15 L16.5 15 Z" />
      </svg>
      <svg className="animate-twinkle-slow absolute right-[26%] top-[30%] h-4 w-4 text-cream/60" viewBox="0 0 40 40" fill="currentColor">
        <path d="M20 2 L23.5 15 L37 15 L26 23 L30 37 L20 28 L10 37 L14 23 L3 15 L16.5 15 Z" />
      </svg>
    </div>
  );
}

// Décoration saisonnière du héros d'accueil — choisie automatiquement selon la date.
export function SeasonDecor() {
  const season = getSeason();
  if (!season) return null;
  return season.id === "halloween" ? <HalloweenDecor /> : <ChristmasDecor />;
}

// Silhouettes Halloween sobres (crème/terracotta) posées sur le héros de l'accueil.
export function HalloweenDecor() {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-[5] overflow-hidden">
      {/* Toile d'araignée — coin haut droit */}
      <svg
        className="absolute right-0 top-0 h-40 w-40 text-cream/20 sm:h-60 sm:w-60"
        viewBox="0 0 100 100"
        fill="none"
        stroke="currentColor"
        strokeWidth="0.7"
      >
        <path d="M100 0 L12 88" /><path d="M100 0 L38 100" /><path d="M100 0 L72 100" />
        <path d="M100 0 L100 62" /><path d="M100 0 L100 30" />
        <path d="M78 0 A22 22 0 0 1 100 22" /><path d="M58 0 A42 42 0 0 1 100 42" />
        <path d="M36 0 A64 64 0 0 1 100 64" /><path d="M14 0 A86 86 0 0 1 100 86" />
      </svg>
      {/* Toile d'araignée — coin haut gauche, miroir */}
      <svg
        className="absolute left-0 top-0 hidden h-36 w-36 -scale-x-100 text-cream/15 sm:block sm:h-48 sm:w-48"
        viewBox="0 0 100 100"
        fill="none"
        stroke="currentColor"
        strokeWidth="0.7"
      >
        <path d="M100 0 L12 88" /><path d="M100 0 L38 100" /><path d="M100 0 L72 100" />
        <path d="M100 0 L100 62" /><path d="M100 0 L100 30" />
        <path d="M78 0 A22 22 0 0 1 100 22" /><path d="M58 0 A42 42 0 0 1 100 42" />
        <path d="M36 0 A64 64 0 0 1 100 64" /><path d="M14 0 A86 86 0 0 1 100 86" />
      </svg>
      {/* Araignée suspendue */}
      <svg className="animate-float-soft absolute right-[16%] top-0 hidden h-24 w-10 text-cream/30 md:block" viewBox="0 0 40 100" fill="currentColor">
        <line x1="20" y1="0" x2="20" y2="66" stroke="currentColor" strokeWidth="1" />
        <ellipse cx="20" cy="76" rx="7" ry="9" />
        <circle cx="20" cy="66" r="4" />
        <path d="M13 74 q-8 2 -9 10 M27 74 q8 2 9 10 M14 70 q-9 -2 -10 6 M26 70 q9 -2 10 6" stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinecap="round" />
      </svg>
      {/* Citrouilles — bas gauche */}
      <svg className="animate-float-soft absolute bottom-8 left-6 h-16 w-16 text-terracotta/70 sm:h-24 sm:w-24" viewBox="0 0 64 64" fill="currentColor">
        <path d="M32 10 q1 -7 7 -7" stroke="currentColor" strokeWidth="3.5" fill="none" strokeLinecap="round" />
        <ellipse cx="32" cy="38" rx="24" ry="20" />
        <path d="M32 20 q-6 18 0 36 M20 24 q-5 14 0 28 M44 24 q5 14 0 28" stroke="#1d120c" strokeWidth="1.6" fill="none" opacity="0.35" />
      </svg>
      <svg className="animate-float-soft-slow absolute bottom-6 left-24 hidden h-12 w-12 text-[#c98a4b]/60 sm:block" viewBox="0 0 64 64" fill="currentColor">
        <path d="M32 10 q1 -7 7 -7" stroke="currentColor" strokeWidth="3.5" fill="none" strokeLinecap="round" />
        <ellipse cx="32" cy="38" rx="24" ry="20" />
        <path d="M32 20 q-6 18 0 36 M20 24 q-5 14 0 28 M44 24 q5 14 0 28" stroke="#1d120c" strokeWidth="1.6" fill="none" opacity="0.35" />
      </svg>
      {/* Petit fantôme flottant */}
      <svg className="animate-float-soft-slow absolute bottom-28 right-28 h-14 w-12 text-cream/35 sm:h-20 sm:w-16" viewBox="0 0 48 56" fill="currentColor">
        <path d="M24 4 C13 4 8 14 8 26 L8 50 L14 44 L19 50 L24 44 L29 50 L34 44 L40 50 L40 26 C40 14 35 4 24 4 Z" />
        <circle cx="18" cy="24" r="3" fill="#1d120c" />
        <circle cx="30" cy="24" r="3" fill="#1d120c" />
      </svg>
      {/* Chauves-souris */}
      <svg className="animate-float-soft absolute left-[38%] top-[16%] hidden h-6 w-14 text-cream/30 md:block" viewBox="0 0 56 20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
        <path d="M2 14 Q9 2 16 12 Q23 2 28 12 Q33 2 40 12 Q47 2 54 14" />
      </svg>
      <svg className="animate-float-soft-slow absolute left-[55%] top-[26%] hidden h-4 w-10 text-cream/25 md:block" viewBox="0 0 56 20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
        <path d="M2 14 Q9 2 16 12 Q23 2 28 12 Q33 2 40 12 Q47 2 54 14" />
      </svg>
    </div>
  );
}
